/**
 * ChannelListingCtrl controller
 *
 * @class ChannelListingCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:ChannelListingCtrl
 */
/* @ngInject */
export default function ChannelListingCtrl (subscriptions) {
  const vm = this
  vm.subscription = {}
  vm.subscriptions = subscriptions
}
